export default "__VITE_ASSET__BF13rN2H__"